import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import { Leave } from "./getLeave";

export type LeavePayload = {
  leaveType: string;
  reason: string;
  toDate: string;
  fromDate: string;
};

export type LeaveResponse = {
  success: boolean;
  message: string;
  data: Leave[];
};

const addLeave = async (payload: LeavePayload): Promise<LeaveResponse> => {
  const { data } = await customAxios.post<LeaveResponse>(
    "/leaves/request",
    payload
  );
  return data;
};

export const useLeaveAdd = () => {
  const queryClient = useQueryClient();

  return useMutation<LeaveResponse, AxiosError, LeavePayload>({
    mutationFn: addLeave,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });
      await queryClient.invalidateQueries(["leave"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to add leave request",
        color: "red",
      }),
  });
};
